/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Tutorial_RotateInputs */

const en_camera_tutorial_rotate = /** @type {(inputs: Camera_Tutorial_RotateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left click · rotate`)
};

const fr_camera_tutorial_rotate = /** @type {(inputs: Camera_Tutorial_RotateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clic gauche · rotation`)
};

const ms_sg2_camera_tutorial_rotate = /** @type {(inputs: Camera_Tutorial_RotateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik kiri · putar`)
};

/**
* | output |
* | --- |
* | "Left click · rotate" |
*
* @param {Camera_Tutorial_RotateInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_tutorial_rotate = /** @type {((inputs?: Camera_Tutorial_RotateInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Tutorial_RotateInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_tutorial_rotate(inputs)
	if (locale === "fr") return fr_camera_tutorial_rotate(inputs)
	return ms_sg2_camera_tutorial_rotate(inputs)
});